import classNames from 'classnames';
import React from 'react';
import { HeaderApp } from '../Header';

import styles from './styles.module.scss';

const Page: React.FC = ({ children }) => (
  <>
    <HeaderApp />
    <main
      className={classNames(
        styles.mainContent,
        'flex-fill d-flex flex-column',
      )}
    >
      <div className="container-fluid py-4 d-flex flex-column flex-fill">
        {children}
      </div>
    </main>
  </>
);

export default Page;
